import { array, number, object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';
import {
    getFieldsToRender,
    getMinMaxBuildHeight,
    getMinMaxCeilTilt,
    getMinMaxFrontBaseHeight,
    getMinMaxOuterRailLength,
    getMinMaxRailSpacing,
    getMinMaxSeamDistance,
} from 'common/utils/helpers/systemsValues';

export const getExtraFieldsValidationSchema = (values) => {
    const {
        NUMBER_TYPE_TEXT,
        REQUIRED_TEXT,
        getMinValueText,
        getMaxValueText,
    } = getValidationTexts();

    const { system_uid } = values;

    const extraFieldsToValidate = getFieldsToRender(system_uid);

    const extraFields = {};

    if (extraFieldsToValidate.includes('sloof_type')) {
        extraFields.sloof_type = string().required(REQUIRED_TEXT);
    }

    if (extraFieldsToValidate.includes('ceil_tilt')) {
        const [minValue, maxValue] = getMinMaxCeilTilt(system_uid);
        extraFields.ceil_tilt = number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(minValue, getMinValueText(minValue))
            .max(maxValue, getMaxValueText(maxValue));
    }

    if (extraFieldsToValidate.includes('rail_spacing')) {
        const { strategy } = values.rail_spacing;
        let fieldValidation = {};

        if (strategy === 'manual') {
            fieldValidation = {
                strategy: string().typeError(REQUIRED_TEXT).nullable(),
                value: array()
                    .of(string())
                    .min(1, 'Selecciona al menos 1 opción')
                    .required(REQUIRED_TEXT),
            };

            extraFields.rail_spacing = object().shape(fieldValidation);
        }
        if (strategy === 'custom') {
            const [minValue, maxValue] = getMinMaxRailSpacing();
            extraFields.rail_spacing = object().shape({
                ...fieldValidation,
                custom_value: number()
                    .typeError(NUMBER_TYPE_TEXT)
                    .required(REQUIRED_TEXT)
                    .min(minValue, getMinValueText(minValue))
                    .max(maxValue, getMaxValueText(maxValue)),
            });
        }
    }

    if (extraFieldsToValidate.includes('rail_support_length')) {
        const { strategy } = values.rail_support_length;
        if (strategy === 'manual') {
            extraFields.rail_support_length = object().shape({
                strategy: string().typeError(REQUIRED_TEXT).nullable(),
                value: string().required(REQUIRED_TEXT),
            });
        }
    }

    if (extraFieldsToValidate.includes('plate_support_length')) {
        const { strategy } = values.plate_support_length;
        if (strategy === 'manual') {
            extraFields.plate_support_length = object().shape({
                strategy: string().typeError(REQUIRED_TEXT).nullable(),
                value: string().required(REQUIRED_TEXT),
            });
        }
    }

    if (extraFieldsToValidate.includes('beam_spacing')) {
        const { strategy } = values.beam_spacing;
        if (strategy === 'manual') {
            extraFields.beam_spacing = object().shape({
                strategy: string().typeError(REQUIRED_TEXT).nullable(),
                value: string().required(REQUIRED_TEXT),
            });
        }
    }

    if (extraFieldsToValidate.includes('support_length')) {
        const { strategy } = values.support_length;
        if (strategy === 'manual') {
            extraFields.support_length = object().shape({
                strategy: string().typeError(REQUIRED_TEXT).nullable(),
                value: string().required(REQUIRED_TEXT),
            });
        }
    }

    if (extraFieldsToValidate.includes('lfoot_supports_width')) {
        const { strategy } = values.lfoot_supports_width;
        if (strategy === 'manual') {
            extraFields.lfoot_supports_width = object().shape({
                strategy: string().typeError(REQUIRED_TEXT).nullable(),
                value: string().required(REQUIRED_TEXT),
            });
        }
    }

    if (extraFieldsToValidate.includes('gclamp_type')) {
        extraFields.gclamp_type = string().required(REQUIRED_TEXT);
    }

    if (extraFieldsToValidate.includes('seam_distance')) {
        const [minValue, maxValue] = getMinMaxSeamDistance(system_uid);
        extraFields.seam_distance = number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(minValue, getMinValueText(minValue))
            .max(maxValue, getMaxValueText(maxValue));
    }

    if (extraFieldsToValidate.includes('outer_rail_length')) {
        const { strategy } = values.outer_rail_length;
        if (strategy === 'manual') {
            const [minValue, maxValue] = getMinMaxOuterRailLength();
            extraFields.outer_rail_length = object().shape({
                strategy: string().typeError(REQUIRED_TEXT).nullable(),
                value: number()
                    .typeError(NUMBER_TYPE_TEXT)
                    .required(REQUIRED_TEXT)
                    .min(minValue, getMinValueText(minValue))
                    .max(maxValue, getMaxValueText(maxValue)),
            });
        }
    }

    if (extraFieldsToValidate.includes('front_base_height')) {
        const { strategy } = values.front_base_height;
        if (strategy === 'manual') {
            const [minValue, maxValue] = getMinMaxFrontBaseHeight();
            extraFields.front_base_height = object().shape({
                strategy: string().typeError(REQUIRED_TEXT).nullable(),
                value: number()
                    .typeError(NUMBER_TYPE_TEXT)
                    .required(REQUIRED_TEXT)
                    .min(minValue, getMinValueText(minValue))
                    .max(maxValue, getMaxValueText(maxValue)),
            });
        }
    }

    return extraFields;
};

export const getCommonFieldsValidationSchema = (values) => {
    const { getMinValueText, NUMBER_TYPE_TEXT, REQUIRED_TEXT } =
        getValidationTexts();

    const { system_uid } = values;

    const [buildingHeightMinValue] = getMinMaxBuildHeight(system_uid);

    const fields = {
        building_height: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(
                buildingHeightMinValue,
                getMinValueText(buildingHeightMinValue),
            )
            .nullable(),
        category: string().required(REQUIRED_TEXT),
        system: string().required(REQUIRED_TEXT),
        system_uid: string().required(REQUIRED_TEXT),
        type_application: string().required(REQUIRED_TEXT),
    };

    return fields;
};
